import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { BRAND } from "@/lib/constants";
import { Phone } from "lucide-react";

export default function Navbar({ variant = "marketing" }) {
  const { user, logout } = useAuth();
  const loc = useLocation();

  const dashHref = user
    ? user.role === "dispatcher"
      ? "/dispatcher"
      : user.role === "driver"
      ? "/driver"
      : "/customer"
    : "/login";

  return (
    <header
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-40 backdrop-blur-md bg-black/70 border-b border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <img src="/logos/monogram.png" alt="Delux Limo Trans Group" className="w-10 h-10 object-contain"/>
          <div className="hidden sm:flex flex-col leading-tight">
            <span className="font-serif text-base tracking-wide text-[#F5F2EB]">Delux Limo</span>
            <span className="text-[10px] tracking-[0.28em] uppercase text-[#A1A1AA]">Trans Group</span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-10 text-sm">
          <Link to="/" data-testid="nav-home" className={navLink(loc.pathname === "/")}>Home</Link>
          <Link to="/book" data-testid="nav-book" className={navLink(loc.pathname === "/book")}>Book a Ride</Link>
          <Link to="/events" data-testid="nav-events" className={navLink(loc.pathname === "/events")}>Weddings &amp; Events</Link>
          <Link to="/lookup" data-testid="nav-lookup" className={navLink(loc.pathname === "/lookup")}>Find Reservation</Link>
          {!user && (
            <Link
              to="/login"
              data-testid="nav-staff"
              className={navLink(false)}
            >
              Staff Portal
            </Link>
          )}
          <a href={`tel:${BRAND.phones[0].replace(/[^0-9+]/g, "")}`} className="flex items-center gap-2 text-[#A1A1AA] hover:text-[#D4AF37] transition-colors">
            <Phone size={14} /> {BRAND.phones[0]}
          </a>
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <Link to={dashHref} data-testid="nav-dashboard" className="hidden sm:inline-flex text-sm text-[#F5F2EB] hover:text-[#D4AF37] transition-colors uppercase tracking-[0.18em]">
                Dashboard
              </Link>
              <button
                data-testid="nav-logout"
                onClick={logout}
                className="text-xs uppercase tracking-[0.2em] text-[#A1A1AA] hover:text-[#D4AF37] transition-colors"
              >
                Sign out
              </button>
            </>
          ) : (
            <Link to="/login" data-testid="nav-login" className="btn-ghost !py-2.5 !px-5 text-[11px]">
              Sign in
            </Link>
          )}
          <Link to="/book" data-testid="nav-cta" className="btn-gold !py-2.5 !px-5 text-[11px]">
            Book Now
          </Link>
        </div>
      </div>
    </header>
  );
}

function navLink(active) {
  return `font-sans text-[13px] tracking-[0.16em] uppercase transition-colors ${active ? "text-[#D4AF37]" : "text-[#A1A1AA] hover:text-[#F5F2EB]"}`;
}
